/* oxlint-disable typescript/no-explicit-any -- attributes/match vars can be any type */
// Process inline directives
// ::name[inline content]{attributes}
// Example: ::cite[smith04]

import type StateInline from '../state-inline'
import { parseAttributeBlock } from '../../helpers/parse-attribute-block'

export default function directive_inline(
  state: StateInline,
  silent: boolean,
): boolean {
  const start = state.pos
  const max = state.posMax

  // Check for opening ::
  if (state.src.charCodeAt(start) !== 0x3a /* : */) return false
  if (state.src.charCodeAt(start + 1) !== 0x3a /* : */) return false

  let pos = start + 2
  const nameStart = pos

  // Parse name: alphanumeric, -, _
  // Cannot end with - or _
  while (pos < max) {
    const code = state.src.charCodeAt(pos)
    if (
      (code >= 0x30 && code <= 0x39) || // 0-9
      (code >= 0x41 && code <= 0x5a) || // A-Z
      (code >= 0x61 && code <= 0x7a) || // a-z
      code === 0x2d || // -
      code === 0x5f // _
    ) {
      pos++
    } else {
      break
    }
  }

  const name = state.src.slice(nameStart, pos)

  // Name is required
  if (name.length === 0) return false

  // Name cannot end with - or _
  const lastChar = name[name.length - 1]
  if (lastChar === '-' || lastChar === '_') return false

  // Parse optional [content]
  let content = ''
  if (pos < max && state.src.charCodeAt(pos) === 0x5b /* [ */) {
    const contentStart = pos + 1
    let depth = 1
    pos++

    while (pos < max && depth > 0) {
      const code = state.src.charCodeAt(pos)
      if (code === 0x5b /* [ */) depth++
      else if (code === 0x5d /* ] */) depth--

      if (depth > 0) pos++
    }

    if (depth === 0) {
      content = state.src.slice(contentStart, pos)
      pos++ // Skip closing ]
    } else {
      return false // Unmatched [
    }
  }

  // Parse optional {attributes}
  let attributes: Record<string, any> = {}
  if (pos < max) {
    const attrRes = parseAttributeBlock(state.src, pos, max)
    if (attrRes.ok) {
      attributes = attrRes.attributes
      pos = attrRes.pos
    }
  }

  if (!silent) {
    const token = state.push('directive_inline', 'span', 0)
    token.meta = {
      name,
      content,
      attributes,
    }
    token.markup = '::'
  }

  state.pos = pos
  return true
}
